<template>
  <div class="permissionEdit">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="菜单名称：" prop="title" style="margin-bottom: 15px">
        <div>{{ ruleForm.title }}</div>
        <!-- <el-input
          v-model="ruleForm.title"
          style="width: 300px"
          placeholder="请输入菜单名称"
          disabled="true"
        ></el-input> -->
      </el-form-item>
      <el-form-item label="菜单排序：" prop="sort">
        <el-input-number
          v-model="ruleForm.sort"
          controls-position="right"
          @change="handleChange"
          :min="1"
          :max="100"
          style="width: 300px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="是否显示：">
        <el-switch v-model="ruleForm.isHome"></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        appType: null,
        isHome: true,
        sort: 50,
        title: "",
        id: undefined,
      },
      rules: {},
    };
  },
  created() {
    let query = this.$route.query;
    this.ruleForm.appType = query.appType;
    if (query.kv) {
      console.log(query.kv);
      this.load(query.kv);
    }
  },
  methods: {
    async load(id) {
      let q = {};
      const res = await $utils.api.load(
        `/admin/system/sysCustomerMobileFunction/getInfo/${id}`,
        q,
        "GET"
      );
      if (res.code == 200) {
        const data = res.data;
        this.ruleForm.id = data.id;
        this.ruleForm.title = data.title;
        this.ruleForm.isHome = data.isHome;
        this.ruleForm.sort = data.sort;
      }
      console.log(res);
    },
    handleChange(value) {
      console.log(value);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);

          $utils.api
            .load(
              "/admin/system/sysCustomerMobileFunction",
              this.ruleForm,
              "PUT"
            )
            .then((res) => {
              if (res.code == 200) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            });

          //   alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.permissionEdit {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 62px;
    height: 62px;
    box-sizing: border-box;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff;
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  /deep/ .el-input__inner {
    height: 35px;
  }
  /deep/.el-input-number {
    line-height: 35px !important;
  }
  /deep/ .el-input-number.is-controls-right .el-input-number__decrease {
    line-height: 17px !important;
  }
  /deep/ .el-input-number.is-controls-right .el-input-number__increase {
    line-height: 17px !important;
  }

  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
  .avatar-uploader {
    height: 62px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}
</style>